import { render, staticRenderFns } from "./detailPagePurchseSettlement.vue?vue&type=template&id=bca95a3c&scoped=true&"
import script from "./detailPagePurchseSettlement.vue?vue&type=script&lang=js&"
export * from "./detailPagePurchseSettlement.vue?vue&type=script&lang=js&"
import style0 from "./detailPagePurchseSettlement.vue?vue&type=style&index=0&id=bca95a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca95a3c",
  null
  
)

export default component.exports